import Vue from 'vue';
import App from './App.vue';
import {router,resetRouter} from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题

//弹窗拖拽
import './assets/js/directives';

// import 'babel-polyfill';

// Lodash 是一个流行的 JavaScript 实用工具库，提供了许多常用的函数和工具，能够方便地处理集合、字符串、数值、函数等多种数据类型，减少编写重复代码的时间和精力
import _ from 'lodash';
Vue.prototype._ = _;

//全局取消dialog点击遮罩层关闭效果
ElementUI.Dialog.props.closeOnClickModal.default = false;

// //加载视频组件
// import VideoPlayer from 'vue-video-player'
// require('vue-video-player/src/custom-theme.css')
// require('video.js/dist/video-js.css')
// Vue.use(VideoPlayer)

// Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {size: 'small'});
// const i18n = new VueI18n({locale: 'zh',messages});

import globalBase from './global_base';
Vue.use(globalBase);

import globalWallet from './global_wallet';
Vue.use(globalWallet);

import { getUser,getAuthToken, getMenuList ,isSuperUser} from '@/assets/js/user';
import { getDict,setDict } from '@/assets/js/config';
import { sysDictApi } from '@/api/api-sys';
sysDictApi.findList({}).then(res => {
    setDict(res);
});

function getViews(path) {
    return resolve => {
        require.ensure([], (require) => {
            resolve(require('@/views/' + path + '.vue'))
        })
    };
}


let registerRouteFresh = true
let createRouter = function () {
    let menuList = getMenuList();
    let childrenRouter = [];
    for (let pmenu of menuList) {
        for (let smenu of pmenu.children) {
            let data = {};
            console.log(smenu.url);
            data['path'] = smenu.url.replace("/", "_").toLocaleLowerCase();
            data['name'] = smenu.label;
            data['component'] = getViews(smenu.url);
            childrenRouter.push(data);
        }
    }

    let routerArray = [];
    routerArray.push({path: '/',component: getViews("home/Home"),children: childrenRouter});
    // routerArray.push({path: '/login',component: getViews("common/Login")});
    // routerArray.push({path: '/',redirect: '/login'});
    // routerArray.push({path: '/403',component: getViews("common/403")});
    // routerArray.push({path: '*',component: getViews("common/404")});
    console.log("router:",router);
    resetRouter();
    router.addRoutes(routerArray);
    registerRouteFresh = false;
}
Vue.prototype.createRouter = createRouter;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        next();
    } else {
        let user = getUser();
        if (!user) {
            next('/login');
        } else {
            if (registerRouteFresh) {
                createRouter();
                next(to.fullPath);
            } else {
                next();
            }
        }
    }
});

// Echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

new Vue({router,render: h => h(App)}).$mount('#app');